
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

import './info-call.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function CallReportResume(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(data)
    const [positive, setPositive] = useState(0)
    const [neutro, setNeutro] = useState(0)
    const [negative, setNegative] = useState(0)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        setCall(data)
        let positive_count = 0
        let negative_count = 0
        let neutro_count = 0
        let total_sum = 0 
        call?.sentiment.map((item, idex) => {
            if (item.polarity == 'POS') {
                positive_count = positive_count + 1
                total_sum = total_sum + 1
            }
            else if (item.polarity == 'NEU') {
                neutro_count = neutro_count  + 1
                total_sum = total_sum + 0
            }
            else if (item.polarity == 'NEG') {
                negative_count = negative_count  + 1
                total_sum = total_sum - 1
            }
        })
        setNegative(negative_count)
        setPositive(positive_count)
        setNeutro(neutro_count)
        const score = (total_sum/ (call?.sentiment?.length || 1 ))
        setTotal(((score + 1) / 2).toFixed(2))

    }, [data])

    return (

        <>
            <div class="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <div class="info-call-item header">
                    <div class="item">
                        <h4 className="font-bold  text-[#0B5FA3] text-[18px]">Call Time</h4>
                        <span class="duration-call text-[#575756] text-[29px]">{call?.time_call}</span>
                        <div class="subitems">
                            <div>
                                <h4 className='font-bold text-[#0B5FA3]'>N° Times in Hold</h4>
                                <span className='text-[#575756]'>{call.time_hold}</span>
                            </div>
                            <div>
                                <h4 className='font-bold text-[#0B5FA3]'>Total Hold Time (sec)</h4>
                                <span className='text-[#575756]'>{call.second_hold}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <h4 style={{fontWeight: "bold",color: "#0B5FA3", fontSize: 18}}>Score</h4>
                        <span class="porcentaje" style={{color: '#0B5FA3', fontSize: 39}}>{Number((call.qualification * 100).toFixed(1))}%</span>
                    </div>

                    <div style={{ marginTop: 20, padding: 10, fontSize: 16 }}>
                        <h4 style={{ fontSize: 18, fontWeight: "bold",color: "#0B5FA3" }}>Bot sentiment result:</h4>
                        <div class="d-flex flex-row align-items-center"
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: "#575756" }} >
                            <div class="m-1" style={{ fontWeight: "bold",color: '#575756' }}>Positive:</div>
                            <div style={{ marginLeft: 3 }}>{positive}</div>
                        </div>
                        <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#575756' }}>
                            <div style={{ fontWeight: "bold",color: '#575756' }}>Neutral:</div>
                            <div style={{ marginLeft: 3 }}>{neutro}</div>
                        </div>
                        <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#575756' }}>
                            <div style={{ fontWeight: "bold",color: '#575756' }}>Negative:</div>
                            <div style={{ marginLeft: 3 }}>{negative}</div>
                        </div>
                        <div class="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: "#575756" }}>
                            <div class="m-1" style={{ fontWeight: "bold",color: '#575756' }}>Polarity score:</div>
                            <div style={{ marginLeft: 3, letterSpacing: 1 }}>{total}</div>
                        </div>
                    </div>

                    <div class="highlights">
                        <h4 style={{ padding: 0, margin: 0 ,fontWeight: "bold", color: "#0B5FA3"}}>Highlights</h4>
                        <div>
                            <img src="/icons/sentiment2.png" alt="" style={{ width: 142, height: 143, objectFit: 'contain' }} />
                        </div>
                    </div>
                </div>
                <div class="info-call-item body">
                    <div>
                        <h2 className="font-bold  text-[#0B5FA3] text-[18px]" >Hits</h2>
                        <div class="container-call-info">
                            <ComplianceHits data={call} />
                        </div>
                    </div>
                    <div style={{ paddingRight: 15}}>
                        <h2 className="font-bold  text-[#0B5FA3] text-[18px]" >Improvements</h2>
                        <div class="container-call-info"   >
                            <ComplianceImprovents data={call} />
                        </div>
                    </div>
                </div>
                {/* <div class="info-call-item fotter">
                    <app-fotter-info-call></app-fotter-info-call>
                </div> */}
            </div>
            {/* <div>
                <div class="container_error_image">
                    <h2>Sorry !</h2>
                    <h6>
                        {{ message }}
                    </h6>
                </div>
                <div class="item-close" *ngIf="showRetry">
                <button (click)="retryAssesment()">
                Retry
            </button>
        </div> */}



        </>


    )
}
